import { forwardRef, Ref, type SVGProps } from 'react';

const SvgSeagrass = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      fill="#033532"
      d="M2.094 3.388h2.262l-.469 4.355 1.633 5.688.665 1.323.976-.392-1.205-6.155.406-5.707h3.116L8.284 8.08l1.806 3.087.204 4.846.572.568.67-.527.203-4.846-1.323-3.931L11.74 2.5l3.116.254-1.759 4.186 1.366 3.686-.322 4.122.051 1.407 1.645-.533 1.066-5.048-1.048-3.297.45-3.255 2.092-.212.854 6.594-.512 4.489-3.456 4.607H6.275l-3.5-4.987s-.98-5.122-1.023-5.292.34-5.833.34-5.833"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSeagrass);
export default ForwardRef;
